import IcTip from "@/assets/svg/ic_tip.svg?react";

function Tip() {
  return (
    <div className="position-absolute mx-8 top--21.5 left-1 w-55 p-x-4 p-y-3 flex text-3.5 text-mx-white bg-mx-primary rounded-1.5 after:w-3 after:h-3 after:position-absolute after:bottom--1.5 after:left-4 after:w-0 after:border-l after:content-empty after:bg-mx-primary after:rotate-45 after:rounded-br-1">
      <IcTip className="w-5 h-5 m-r-1 min-w-5"></IcTip>
      <div>你也可以切换音频采集设备，提升语音采集的质量</div>
    </div>
  );
}

export default Tip;
